export const ssrSuccess = (config, _data, globalConfig) => {
  if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) {
    return {
      'ssr:success': true
    };
  }

  return null;
};